import useSession from "../../services/state/session/useSession";
import FilterContainer from "../../component/general/filter/FilterContainer";
import FilterGroup from "../../component/general/filter/FilterGroup";
import FilterItemSelect from "../../component/general/filter/FilterItemSelect";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setPreference} from "../../../redux/slice/pricingSlice";
import {DiscountDetail} from "./discountDetail";

const DiscountController = () => {

    const session = useSession();
    const discountSchema = session?.sessionData?.discountSchema;
    const { preferences } = useSelector(state => state.session.pricing);
    const dispatch = useDispatch();

    if(!discountSchema || !discountSchema.M_DiscountSchemaRule) return (<></>)

    const options = DiscountDetail.getPreferenceOptions(discountSchema);

    const onPreferenceChange = (preference, value) => {
        dispatch(setPreference([preference, value]));
    }

    return (
        <FilterContainer header={"Pricing Controls"}>
            {options.map((option, i) =>
                <FilterGroup key={i} name={option.name}>
                    {option.values.map((v, j) =>
                        <FilterItemSelect
                            key={j}
                            name={v}
                            selected={preferences?.[option.name] === v}
                            onSelectChange={() => onPreferenceChange(option.name, v)}
                        />
                    )}
                </FilterGroup>
            )}
            <div className="filter-update-container">
                <p>Clear Settings</p>
            </div>
        </FilterContainer>
    )
}


export default DiscountController;